import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FileTransferFileData, FiletransferLibService, FileTransferHostConfig } from 'filetransfer-lib';
import { concat, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/internal/operators';
import { environment } from 'src/environments/environment';
import { MultimediaManagerDialogService } from '../multimedia-manager-dialog/multimedia-manager-dialog.service';
import { MultimediaManagerDialogUploaderService } from './multimedia-manager-dialog-uploader.service';
import { MultimediaManagerDialogUrlComponent } from './multimedia-manager-dialog-url/multimedia-manager-dialog-url.component';
import { MultimediaManagerDialogWebscriptComponent } from './multimedia-manager-dialog-webscript/multimedia-manager-dialog-webscript.component';

@Component({
  selector: 'app-multimedia-manager-dialog-uploader',
  templateUrl: './multimedia-manager-dialog-uploader.component.html',
  styleUrls: ['./multimedia-manager-dialog-uploader.component.scss']
})
export class MultimediaManagerDialogUploaderComponent implements OnInit {

  @ViewChild('uploadInput', { static: false }) uploadInput: ElementRef;

  constructor(private multimediaManagerDialogService: MultimediaManagerDialogService,
              private multimediaManagerDialogUploaderService: MultimediaManagerDialogUploaderService,
              private filetransferLibService: FiletransferLibService,
              private dialog: MatDialog) {
              }

  ngOnInit() {
    this.multimediaManagerDialogUploaderService.listen_finished().subscribe(
      (res) => {
        this.multimediaManagerDialogService.folderChanged(this.multimediaManagerDialogService.getCurrentFolder());
        this.multimediaManagerDialogUploaderService.percent({fileName: res['messageContent'].split('--')[1], percent: 'Finished'});
      }
    );
  }

  public clickUploadInput() {
    this.uploadInput.nativeElement.click();
  }

  public uploadInputChanged(event) {
    const files = this.uploadInput.nativeElement.files;
    const filesSubscribers = [];
    for (const file of files) {
      filesSubscribers.push(of(this.upload(file)));
    }
    concat(filesSubscribers).pipe(
      take(1),
    ).subscribe();
  }

  private upload(file) {
    const fileTransferHostConfig: FileTransferHostConfig = {
      host: environment.filetransfer.host,
      namespace: environment.filetransfer.namespace,
      opts: { path: environment.filetransfer.path, secure: true, rejectUnauthorized: false}
    };
    const fileData: FileTransferFileData = {
      fileName: file.name,
      fileSize: file.size,
      data: file
    };
    this.multimediaManagerDialogUploaderService.askPermissionToUpload(fileData.fileName, this._returnItemType(file.type), fileData.fileSize, this.multimediaManagerDialogService.getCurrentFolder().internalId).pipe(
      take(1),
      map(guid => fileData.fileName = guid + '--' + fileData.fileName ),
      switchMap(renamed => this.filetransferLibService.prepareTransfer(fileTransferHostConfig)),
      switchMap(prepared => this.filetransferLibService.transfer(prepared, fileData))
    ).subscribe(
      (res) => {
        this.multimediaManagerDialogUploaderService.percent({fileName: res['fileName'].split('--')[1], percent: res['percent']});
      }
    );
  }

  private _returnItemType(type): ElementDataTypes {
    switch (type.match(/[^/]*/)[0]) {
      case 'image':
        return ElementDataTypes.IMAGE;
      case 'video':
        return ElementDataTypes.VIDEO;
    }
  }

  public openUrlUploaderDialog() {
    const dialogRef = this.dialog.open(MultimediaManagerDialogUrlComponent);
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          const element = {
            data: result.url,
            name: result.url,
            type: result.type,
            destinyFolderId: this.multimediaManagerDialogService.getCurrentFolder().InternalId };
          this.multimediaManagerDialogUploaderService.saveElement(element).subscribe(
            (res) => {
              this.multimediaManagerDialogService.folderChanged(this.multimediaManagerDialogService.getCurrentFolder());
            }
          );
        }
      }
    );
  }

  public openWebScriptDialog() {
    const dialogRef = this.dialog.open(MultimediaManagerDialogWebscriptComponent);
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          const element = {
            data: result.url,
            name: result.url,
            type: result.type,
            destinyFolderId: this.multimediaManagerDialogService.getCurrentFolder().InternalId };
          this.multimediaManagerDialogUploaderService.saveElement(element).subscribe(
            (res) => {
              this.multimediaManagerDialogService.folderChanged(this.multimediaManagerDialogService.getCurrentFolder());
            }
          );
        }
      }
    );
  }
}

export const enum ElementDataTypes {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}
